import { type ReactNode } from 'react'
import Sidebar from './Sidebar'
import Navbar from './Navbar'
import { useUiStore } from '@/stores/ui-store'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const sidebarOpen = useUiStore((state) => state.sidebarOpen)

  // On mobile (<md) sidebar is an overlay — NEVER push the main content.
  // On desktop (md+) sidebar reserves 16rem (w-64) when open.
  const mainMargin = sidebarOpen ? 'md:ml-64' : 'md:ml-0'

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <Sidebar />
      <main
        className={`ml-0 ${mainMargin} transition-all duration-200 pt-16`}
      >
        {children}
      </main>
    </div>
  )
}
